module.exports = __webpack_public_path__ + "static/img/gst.8a4925d.gif";